import React from 'react'

export const ComponentToPrintShopReport = React.forwardRef(({title, data}, ref) => {
  const convertDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" +  d.getFullYear();
  }
  return (
    <div ref={ref}>
      <center>
      <br />
      <b>{title}</b><br />
      <table width="100%" border="1">
          <tbody>
            <tr>
              <th colSpan="2" />
              <th align="center" colSpan="3">Cash</th>
              <th align="center" colSpan="3">Card</th>
              <th align="center" colSpan="3">UPI</th>
              <th colSpan="2" />
              <th align="center" colSpan="3">0%</th>
              <th align="center" colSpan="3">5%</th>
              <th align="center" colSpan="3">12%</th>
              <th align="center" colSpan="3">18%</th>
              <th colSpan="2" />
            </tr>
            <tr>
              <th align="left">#</th>
              <th align="left">Date</th>
              <th align="right">Cash</th>
              <th align="right">Cash Cancled</th>
              <th align="right">Total Cash</th>
              <th align="right">Card</th>
              <th align="right">Card Cancled</th>
              <th align="right">Total Card</th>
              <th align="right">UPI</th>
              <th align="right">UPI Cancled</th>
              <th align="right">Total UPI</th>
              <th align="right">Total</th>
              <th align="right">Cancel</th>
              <th align="right">Taxable Amt</th>
              <th align="right">CGST</th>
              <th align="right">SGST</th>
              <th align="right">Taxable Amt</th>
              <th align="right">CGST</th>
              <th align="right">SGST</th>
              <th align="right">Taxable Amt</th>
              <th align="right">CGST</th>
              <th align="right">SGST</th>
              <th align="right">Taxable Amt</th>
              <th align="right">CGST</th>
              <th align="right">SGST</th>
              <th align="right">Round Off</th>
              <th align="right">Total Sales</th>
            </tr>
            {data.map((item, index) => (
              <tr key={item._id}>
                <td align="left">{index + 1}</td>
                <td align="left">{convertDate(item._id)}</td>
                <td align="right">{item.cash}</td>
                <td align="right">{item.cash_cancel}</td>
                <td align="right">{item.cash_with_cancel}</td>
                <td align="right">{item.card}</td>
                <td align="right">{item.card_cancel}</td>
                <td align="right">{item.card_with_cancel}</td>
                <td align="right">{item.upi}</td>
                <td align="right">{item.upi_cancel}</td>
                <td align="right">{item.upi_with_cancel}</td>
                <td align="right">{item.total}</td>
                <td align="right">{item.with_cancel}</td>
                <td align="right">{item.gst0_spet}</td>
                <td align="right">{item.gst0_cgst}</td> 
                <td align="right">{item.gst0_sgst}</td> 
                <td align="right">{item.gst5_spet}</td> 
                <td align="right">{item.gst5_cgst}</td> 
                <td align="right">{item.gst5_sgst}</td> 
                <td align="right">{item.gst12_spet}</td> 
                <td align="right">{item.gst12_cgst}</td> 
                <td align="right">{item.gst12_sgst}</td> 
                <td align="right">{item.gst18_spet}</td> 
                <td align="right">{item.gst18_cgst}</td> 
                <td align="right">{item.gst18_sgst}</td> 
                <td align="right">{item.roundoff}</td>
                <td align="right">{item.without_cancel}</td>
              </tr>
            ))}
          </tbody>   
      </table>
    </center>
  </div>
  )
});
